import { Button } from "@/components/Button/Button";
import Separator from "@/components/Separator/Separator";
import * as NavigationMenu from "@radix-ui/react-navigation-menu";

const FooterMeta = ({ items = [], config }) => {
  if (Object.keys(items).length === 0) return null;
  if (Object.keys(config).length === 0) return null;
  return (
    <section
      className="bg-black text-white  lg:min-h-[80px] min-h-[40px]"
      style={{ contentVisibility: "auto" }}
    >
      <div className="w-full container py-7">
        <div className="flex flex-col md:flex-row md:justify-between">
          <div className="md:flex md:flex-col md:justify-between lg:block">
            <p className="text-white text-base leading-2 font-normal mb-5">
              {config?.footer?.meta?.opening?.left?.headline}
            </p>
            <ul className="flex flex-row md:flex-col lg:flex-row mb-8 justify-between">
              <li className="lg:mr-10 mr-5 lg:text-base text-xs">
                <span className="font-bold mr-4">
                  {config?.footer?.meta?.opening?.left?.week?.label}
                </span>
                {config?.footer?.meta?.opening?.left?.week?.value}
              </li>
              <li className="mr-5 lg:text-base text-xs">
                <span className="font-bold mr-4">
                  {config?.footer?.meta?.opening?.left?.weekend?.label}
                </span>

                {config?.footer?.meta?.opening?.left?.weekend?.value}
              </li>
            </ul>
          </div>
          <div>
            <p className="text-white text-base leading-2 font-normal mb-7 lg:mb-5 ">
              {config?.footer?.meta?.opening?.right?.headline}
            </p>
            <div className="flex flex-col lg:flex-row lg:gap-9">
              <div className="flex lg:order-2 order-1 mb-6 lg:mb-8 2xl:ml-8">
                <Button
                  as="a"
                  className="!py-4 !px-4 cursor-pointer w-fit lg:mt-[-8px] mb-4 lg:mb-0 group"
                  href={config?.footer?.meta?.opening?.right?.button?.link}
                >
                  <span className=" pb-1 border-b-[1px] border-transparent group-hover:border-white">
                    {config?.footer?.meta?.opening?.right?.button?.label}
                  </span>
                </Button>
              </div>
              <div className="flex flex-col lg:flex-row mb-8 lg:order-1">
                <ul className="flex flex-row md:flex-col lg:flex-row justify-between">
                  <li className="lg:mr-10 mr-5  lg:text-base text-xs">
                    <span className="font-bold mr-4 ">
                      {config?.footer?.meta?.opening?.right?.week?.label}
                    </span>
                    {config?.footer?.meta?.opening?.right?.week?.value}
                  </li>
                  <li className="mr-5 lg:text-base text-xs">
                    <span className="font-bold mr-4 ">
                      {config?.footer?.meta?.opening?.right?.weekend?.label}
                    </span>
                    {config?.footer?.meta?.opening?.right?.weekend?.value}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Separator className="!bg-white mb-6" />
        <div className="flex flex-col xl:flex-row ">
          <p className="text-center mb-6  items-center flex justify-center lg:text-base text-sm lg:justify-start lg:w-full w-[60%] lg:mx-0 mx-auto">
            {config?.footer?.meta?.address}
          </p>
          <Separator className="!bg-white mb-6 lg:hidden" />
          <NavigationMenu.Root
            className={`flex justify-center p-4 w-full mb-6 lg:w-auto flex-col lg:flex-row xl:ml-[92px] 2xl:ml-[21.4%]`}
          >
            <NavigationMenu.List className="flex lg:justify-between justify-start w-full flex-nowrap lg:text-base text-sm">
              {items.map(({ title, link, target }) => (
                <NavigationMenu.Item
                  key={link}
                  className="lg:ml-10 w-1/2 l:w-full"
                >
                  <a
                    href={link || "#"}
                    target={target || "_self"}
                    className="pb-3 border-b-[1px] border-transparent hover:border-white"
                  >
                    {title}
                  </a>
                </NavigationMenu.Item>
              ))}
              <NavigationMenu.Item className="lg:ml-10">
                <a
                  href="#"
                  onClick={() => (window as any).UC_SET_VIEW(3)}
                  className="pb-3 border-b-[1px] border-transparent hover:border-white"
                >
                  Dateneinstellungen
                </a>
              </NavigationMenu.Item>
            </NavigationMenu.List>
          </NavigationMenu.Root>
        </div>
        <Separator className="!bg-white mb-6" />
        <p className="text-xs">{config?.footer?.meta?.infoTextTop || ""}</p>
        <p className="text-xs">{config?.footer?.meta?.infoText || ""}</p>
      </div>
    </section>
  );
};

export default FooterMeta;
